export const HOTEL_INFO_SECTION = 'hotel_info_section';
